import { put, takeLeading } from 'redux-saga/effects';

import revenueApi from 'api/revenue';
import { apiErrorHandler } from 'utils';

import { GET_REVENUE_LIST, EXPORT_REVENUE_LIST } from './actionTypes';
import {
  actionGetRevenueListSuccess,
  actionGetRevenueListFailed,
  actionExportRevenueListSuccess,
  actionExportRevenueListFailed,
} from './actions';

function* getRevenueList({ payload }) {
  try {
    const response = yield revenueApi.getRevenueList(payload);

    yield put(actionGetRevenueListSuccess(response.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionGetRevenueListFailed());
  }
}

function* exportRevenueList({ payload }) {
  try {
    const response = yield revenueApi.exportRevenueList(payload);

    window.open(response.payload.downloadUrl, '_blank');

    yield put(actionExportRevenueListSuccess());
  } catch (error) {
    apiErrorHandler(error);

    yield put(actionExportRevenueListFailed());
  }
}

export default function* revenueSaga() {
  yield takeLeading(GET_REVENUE_LIST, getRevenueList);
  yield takeLeading(EXPORT_REVENUE_LIST, exportRevenueList);
}
